import { useMemo } from 'react';
import { useMatches } from 'react-router-dom';
import { pipe, Array as A } from 'effect';

/**
 * The destinations the current address shows, from the outermost down, as the matched routes declare them in `handle`;
 * empty when no route of the case declares the address. Pass a guard declared once per case, not on render.
 */
export const useDestinationsInAddress = <Key extends string>(
  isDestination: (handle: unknown) => handle is { readonly destination: Key },
): Key[] => {
  const matches = useMatches();
  return useMemo(
    () =>
      pipe(
        matches,
        A.map((match) => match.handle),
        A.filter(isDestination),
        A.map(({ destination }) => destination),
      ),
    [matches, isDestination],
  );
};
